<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="top">
          <div class="top-item">
            <span>筛选条件</span>
            <el-input
              placeholder="电话或订单号"
              v-model.trim="orderCondition"
              clearable
              size="small"
            ></el-input>
          </div>
          <div
            class="top-item"
            v-if="currentPage != '/order/takeout' && currentPage != '/order/dy'"
          >
            <span>堂食桌位</span>
            <el-select v-model="tablePositionValue" placeholder="请选择" size="small">
              <el-option
                v-for="item in tablePositionList"
                :key="item.shoppingTableId"
                :label="item.tableName"
                :value="item.shoppingTableId"
              >
                <span
                  style="
                    float: left;
                    width: 60px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  "
                  >{{ item.tableName }}</span
                >
                <span style="float: right; color: #8492a6; font-size: 13px">{{
                  item.tableType
                }}</span>
              </el-option>
            </el-select>
          </div>
          <div class="top-item">
            <span>时间选择</span>
            <el-date-picker
              v-model="orderTime"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="top-item">
            <el-button type="primary" size="small" @click="screenOrder">筛选</el-button>
            <el-button @click="resetScreenData" size="small">重置</el-button>
            <el-button
              type="success"
              @click="openCheckCode()"
              size="small"
              v-if="$route.path == '/order/takeout'"
              >核销</el-button
            >
            <el-button
              @click="batchDelivery"
              type="primary"
              v-if="activeName == 20"
              :disabled="list.length > 0 ? false : true"
              size="small"
              >批量发货</el-button
            >
            <el-button
              type="primary"
              @click="exportOrder"
              v-if="activeName == 20 && orderCategory == 3"
              size="small"
              >导出发货单</el-button
            >
            <el-button
              type="primary"
              v-if="$route.path == '/order' || $route.path == '/order/takeout'"
              @click="exportOrders"
              size="small"
              >导出订单</el-button
            >
          </div>
        </div>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card" v-if="shopInfo.edcShopType != 5">
          <el-tab-pane
            v-for="item in orderClassifyList"
            :key="String(item.orderStatus)"
            :label="String(item.orderNum)"
            :name="String(item.orderStatus)"
          >
            <span slot="label">
              <span>{{ item.orderStatusName }}</span>
              <el-badge
                v-if="
                  item.orderNum &&
                  (item.orderStatus == -21 ||
                    item.orderStatus == 19 ||
                    item.orderStatus == 20 ||
                    item.orderStatus == 31)
                "
                :value="item.orderNum"
                class="item"
              ></el-badge>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="list" v-loading="isLoad">
          <el-checkbox
            label="全选"
            v-if="activeName == 20"
            v-model="totalClick"
            @change="totalChecked"
          ></el-checkbox>
          <div class="order-list" v-if="orderList.length">
            <ul>
              <li v-for="(item, index) in orderList" :key="item.tradeNo">
                <div class="item">
                  <div class="list-header">
                    <span v-if="activeName == 20"
                      ><el-checkbox
                        style="width: 20px"
                        @change="commidityClick(item, index)"
                        v-model="item.click"
                      ></el-checkbox
                    ></span>
                    <span class="order-num">#{{ item.orderNum }}</span>
                    <span class="delivery-time">{{ item.deliveryTime }}</span>
                    <!-- <span class="suggest">建议12:19送达</span> -->
                    <span class="order-no">
                      订单号：{{ item.tradeNo }}
                      <input
                        style="position: absolute; top: 0; left: 0"
                        :value="item.tradeNo"
                        :class="`order-no${index}`"
                      />
                    </span>
                    <el-button type="text" @click="copyOrderNo(index)">复制</el-button>
                  </div>
                  <div class="list-container">
                    <div class="products">
                      <div
                        v-for="(product, productIndex) in item.productsOem"
                        :key="productIndex"
                      >
                        <div
                          class="products-item"
                          v-for="(productItem, itemIndex) in product"
                          :key="itemIndex"
                        >
                          <div class="info">
                            <img
                              :src="productItem.goodsImage"
                              alt
                              v-if="shopInfo.edcShopType != 5"
                            />
                            <div
                              :class="{
                                'no-img': shopInfo.edcShopType == 5,
                              }"
                            >
                              <p class="name" :title="productItem.goodsName">
                                {{ productItem.goodsName }}
                              </p>
                              <p
                                class="desc"
                                v-if="productItem.specDesc && shopInfo.edcShopType != 5"
                                :title="productItem.specDesc"
                              >
                                （{{ productItem.specDesc }}）
                              </p>
                              <p class="desc">
                                {{
                                  productItem.unitType == 2
                                    ? `${productItem.qrcBuyCount}${productItem.goodsUnit}`
                                    : `X${productItem.buyCount}`
                                }}
                              </p>
                              <p class="price">
                                ￥{{ Number(productItem.retailPrice).toFixed(2) }}
                              </p>
                              <p class="oilgun-num" v-if="shopInfo.edcShopType == 5">
                                {{ item.buyerAddress }}
                              </p>
                            </div>
                          </div>
                          <div class="num" v-if="shopInfo.edcShopType != 5">
                            {{
                              productItem.unitType == 2
                                ? `${productItem.qrcBuyCount}${productItem.goodsUnit}`
                                : `X${productItem.buyCount}`
                            }}

                            <span
                              class="num-type"
                              :class="{
                                retreat: productItem.productSaleStatus == 1,
                                give: productItem.productSaleStatus == 4,
                              }"
                              v-if="
                                productItem.productSaleStatus == 1 ||
                                productItem.productSaleStatus == 4
                              "
                              >{{ productItem.productSaleStatus == 1 ? "退" : "赠"
                              }}{{ productItem.buyCount }}</span
                            >
                          </div>
                          <div class="price" v-if="shopInfo.edcShopType != 5">
                            ￥{{ Number(productItem.totalRetailPrice || 0).toFixed(2) }}
                          </div>
                          <div
                            class="action"
                            v-if="
                              item.orderCategory == 5 &&
                              item.orderStatus == 31 &&
                              productItem.productSaleStatus != 1 &&
                              productItem.productSaleStatus != 4 &&
                              shopInfo.edcShopType != 5
                            "
                          >
                            <el-dropdown
                              @command="
                                handleEdit($event, index, productIndex, itemIndex)
                              "
                            >
                              <span class="el-dropdown-link">
                                编辑
                                <i class="el-icon-arrow-down el-icon--right"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="retreat"
                                  >退菜</el-dropdown-item
                                >
                                <el-dropdown-item command="give">赠送</el-dropdown-item>
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                          <div class="action" v-else></div>
                        </div>
                      </div>
                    </div>
                    <div class="time">
                      <div
                        v-for="(product, index) in item.productsOem"
                        :key="index"
                        :style="`flex: ${product.length};`"
                      >
                        <div class="time-item">
                          <p>
                            {{
                              index == item.productsOem.length - 1
                                ? "下单时间"
                                : "加菜时间"
                            }}
                          </p>
                          <p>{{ product[0].createTime.split(".0")[0] }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="info" v-if="shopInfo.edcShopType != 5">
                      <div v-if="item.isPickUp == 1 && item.orderCategory == 3">
                        <p class="takeoutinfo">自提时间：{{ item.deliveryTime }}</p>
                        <p class="address">提货人手机：{{ item.buyerPhone }}</p>
                        <p class="address">自提点：{{ item.buyerAddress }}</p>
                      </div>
                      <div v-if="item.isPickUp != 1 && item.orderCategory == 3">
                        <p class="takeoutinfo">
                          {{ item.buyerName }} {{ item.buyerPhone }}
                        </p>
                        <p class="address">
                          {{ item.buyerAddress }}
                        </p>
                        <p v-if="item.deliveryTime">
                          送达时间：
                          {{ item.deliveryTime }}
                        </p>
                      </div>
                      <p v-if="item.orderCategory != 3" class="tanginfo">
                        <span class="position" v-if="item.buyerAddress"
                          >{{ item.buyerAddress }}号桌</span
                        >
                        <span class="position" v-if="!item.buyerAddress">自助订单</span>
                        <span class="meals-number" v-if="item.mealsNum"
                          >{{ item.mealsNum }}人用餐</span
                        >
                      </p>
                      <p class="mark">备注：{{ item.buyerMark }}</p>
                      <img
                        class="icon-img"
                        :src="
                          item.isPickUp == 1 && item.orderCategory == 3
                            ? pickupPic
                            : item.isPickUp != 1 && item.orderCategory == 3
                            ? takeoutPic
                            : item.orderCategory == 24
                            ? dyPic
                            : tangPic
                        "
                        alt
                      />
                    </div>
                    <div class="price">
                      <p class="total-price">合计：￥{{ item.totalRetailPrice }}</p>
                      <p class="food-box-price" v-if="shopInfo.edcShopType != 5">
                        含餐盒费：￥{{ item.foodBoxPrice }}，配送费：￥{{
                          item.distributionPrice
                        }}
                      </p>
                      <p class="price-msg">
                        会员优惠：-￥{{ item.shopPromotionTotalPrice || 0 }}
                      </p>
                      <p class="price-msg">
                        优惠券：-￥{{ item.cashCouponTotalPrice || 0 }}
                      </p>
                      <p class="price-msg">获取积分：{{ item.userScore || 0 }}</p>
                      <p class="gain-money">整单折后价：￥{{ item.gainMoney }}</p>
                      <p
                        class="price-msg"
                        v-if="
                          item.orderStatus == -21 ||
                          item.orderStatus == -50 ||
                          item.orderStatus == 40 ||
                          item.orderStatus == 35
                        "
                      >
                        支付方式：{{ payInterfacePartyTypes[item.payInterfacePartyType] }}
                      </p>
                      <el-dropdown
                        @command="fullHandleEdit($event, index)"
                        v-if="
                          item.orderStatus == 31 ||
                          item.orderStatus == 10 ||
                          item.orderStatus == 40
                        "
                      >
                        <span class="el-dropdown-link">
                          修改价格
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-if="item.orderStatus == 31 || item.orderStatus == 10"
                            command="priceRevision"
                            >整单改价</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="item.orderStatus == 31 || item.orderStatus == 10"
                            command="discount"
                            >整单打折</el-dropdown-item
                          >
                          <el-dropdown-item v-if="item.orderStatus == 40" command="refund"
                            >整单退款</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div
                      class="action"
                      v-if="orderType[item.orderStatus] && shopInfo.edcShopType != 5"
                    >
                      <p :class="orderType[item.orderStatus].class">
                        {{ orderType[item.orderStatus].title }}
                      </p>
                      <p class="reason" v-if="item.peisongCancelReason">
                        {{ item.peisongCancelReason }}
                      </p>
                      <el-button
                        size="small"
                        type="primary"
                        v-if="orderType[item.orderStatus].btn"
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            item.orderStatus,
                            item.totalRetailPrice,
                            item.entryType,
                            item
                          )
                        "
                        >{{ orderType[item.orderStatus].btn }}</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="item.orderStatus == -21 && currentPage == '/order/takeout'"
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            -22,
                            item.totalRetailPrice,
                            item.entryType
                          )
                        "
                        >拒绝退款</el-button
                      >

                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="
                          ((item.sendType != 5 &&
                            item.sendType != 6 &&
                            !item.eleStatus &&
                            !item.mytStatus &&
                            item.orderStatus == 20) ||
                            (item.sendType == 5 && item.eleStatus == 99) ||
                            (item.sendType == 6 &&
                              (item.mytStatus == 1 ||
                                item.mytStatus == 60 ||
                                item.mytStatus == 70))) &&
                          item.isPickUp != 1
                        "
                        @click="showCargoWeightPop(item)"
                        >配送发单</el-button
                      >
                      <el-button
                        size="small"
                        type="danger"
                        class="create-btn"
                        plain
                        v-if="
                          (item.eleStatus &&
                            item.eleStatus <= 2 &&
                            item.sendType != 5 &&
                            item.isPickUp != 1) ||
                          (item.sendType == 5 &&
                            item.eleStatus == 0 &&
                            item.isPickUp != 1) ||
                          (item.sendType == 6 &&
                            item.mytStatus == 10 &&
                            item.isPickUp != 1)
                        "
                        @click="cancelOrder(shopInfo.sendType, item.mallOrderId)"
                        >取消配送</el-button
                      >
                      <el-link
                        class="status-btn"
                        v-if="
                          ((item.sendType != 5 &&
                            item.eleStatus == 3 &&
                            item.orderStatus == 20) ||
                            (item.sendType == 5 && item.eleStatus == 30) ||
                            (item.sendType == 6 && item.mytStatus == 40)) &&
                          item.isPickUp != 1
                        "
                        :underline="false"
                        type="success"
                        >此单已发送</el-link
                      >
                      <el-link
                        class="status-btn"
                        v-if="
                          (item.sendType != 5 &&
                            item.eleStatus == 5 &&
                            item.isPickUp != 1) ||
                          (item.sendType == 5 &&
                            item.eleStatus > 99 &&
                            item.isPickUp != 1) ||
                          (item.sendType == 6 &&
                            item.mytStatus == 60 &&
                            item.isPickUp != 1)
                        "
                        :underline="false"
                        type="warning"
                        >已取消配送订单</el-link
                      >
                      <el-button
                        size="small"
                        type="primary"
                        v-if="item.orderStatus == -21"
                        @click="handleOrderFuc(item.mallOrderId, -50)"
                        >手动退款</el-button
                      >
                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        v-if="item.isShowWXBtn"
                        @click="createWXInfo(item)"
                        >发货信息录入</el-button
                      >
                    </div>
                    <div class="print">
                      <el-button
                        size="small"
                        type="primary"
                        plain
                        @click="printOrder(index)"
                        >打印小票</el-button
                      >
                      <el-button
                        v-if="item.orderDetailUrl && item.sendType == 6"
                        size="small"
                        type="primary"
                        @click="showAuthQrcode(item.orderDetailUrl)"
                        plain
                        >发单详情</el-button
                      >
                      <el-button
                        v-show="
                          (item.eleStatus == 1 ||
                            item.eleStatus == 2 ||
                            item.eleStatus == 3 ||
                            item.eleStatus == 4 ||
                            item.eleStatus == 10 ||
                            item.eleStatus == 20 ||
                            (item.sendType == 5 && item.eleStatus >= 0) ||
                            (item.sendType == 6 && item.mytStatus == 40)) &&
                          item.isPickUp != 1
                        "
                        class="check-logistics"
                        size="small"
                        type="primary"
                        plain
                        @click="getLogisticsInfo(item.sendType, item.mallOrderId)"
                        >查看物流</el-button
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="list-none">
              <p>暂无更多数据</p>
            </div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="isShowDiscountPop" width="30%">
      <div class="dialog-body">
        <el-input
          placeholder="请输入折扣，如八折输入0.8"
          v-model="discount"
          @input="inputChangeLimitNum"
        ></el-input>
        <div class="tag-list">
          <div
            class="tag"
            :class="{
              sel: !!~tagSelList.indexOf(`${item.goodsCategoryId}`),
              'tag-parent': item.__isParentAll || item.__hasSecondary,
              'tag-child': item.__isSecondary,
            }"
            v-for="item in tagList"
            :key="item.goodsCategoryId"
            :title="item.displayCategoryName || item.categoryName"
            @click="toggleSelType(item)"
          >
            {{ item.displayCategoryName || item.categoryName }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDiscountPop = false">取 消</el-button>
        <el-button type="primary" @click="discountConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="配送发单"
      :visible.sync="isShowCargoWeightPop"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="30%"
    >
      <div class="dialog-body">
        <el-input
          placeholder="请输入斤两"
          v-model="cargoWeight"
          @input="cargoWeightInput"
        ></el-input>
        <div class="dialog-row">
          <span>运费:</span>
          <span v-loading="isComputedFee"> {{ distributionFee }}元 </span>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowCargoWeightPop = false">取 消</el-button>
        <el-button type="primary" @click="deliveryOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="物流信息" :visible.sync="isShowLogisticsInfo" width="496px">
      <div class="logistics-dialog">
        <div class="logistics-header">
          <img class="icon" src="../assets/img/order/icon-ele.png" alt="" />
          <div class="info">
            <div class="name">
              骑手：<strong>{{ logisticsInfo.info.dmName }}</strong>
              <div class="tag">
                {{
                  logisticsInfo.info.sendType == 2
                    ? "达达"
                    : logisticsInfo.info.sendType == 3
                    ? "蜂鸟"
                    : logisticsInfo.info.sendType == 5
                    ? "美团"
                    : logisticsInfo.info.sendType == 6
                    ? "麦芽田"
                    : "闪送"
                }}
              </div>
            </div>
            <div class="phonenum">号码：{{ logisticsInfo.info.dmMobile }}</div>
          </div>
        </div>
        <div class="logistics-body">
          <div class="el-steps-oem">
            <div
              class="el-step-oem active"
              v-for="(item, index) in logisticsInfo.status"
              :key="item.id"
            >
              <div class="index">{{ logisticsInfo.status.length - index }}</div>
              <div
                class="title"
                :class="{
                  active:
                    logisticsInfo.status.length - index == logisticsInfo.status.length,
                }"
              >
                {{
                  logisticsInfo.info.sendType == 5
                    ? mtLogisticsInfoText[item.orderStatus].title
                    : logisticsInfo.info.sendType == 6
                    ? mytLogisticsInfoText[item.orderStatus].title
                    : logisticsInfoText[item.orderStatus].title
                }}
              </div>
              <div class="desc">
                {{
                  logisticsInfo.info.sendType == 5
                    ? mtLogisticsInfoText[item.orderStatus].desc
                    : logisticsInfo.info.sendType == 6
                    ? mytLogisticsInfoText[item.orderStatus].desc
                    : logisticsInfoText[item.orderStatus].desc
                }}
              </div>
              <div class="time">{{ item.modifyTime }}</div>
            </div>
          </div>
          <!-- <el-steps direction="vertical" :active="logisticsInfo.status.length">
            <el-step v-for="item in logisticsInfo.status" :key="item.id">
              <div slot="description">
                <div class="title">
                  {{ logisticsInfoText[item.orderStatus].title }}
                </div>
                <div class="desc">
                  {{ logisticsInfoText[item.orderStatus].desc }}
                </div>
                <div class="time">{{ item.modifyTime }}</div>
              </div>
            </el-step>
          </el-steps> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="取消原因"
      :visible.sync="isShowDadaCancelReasons"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <div class="dialog-body">
        <el-select v-model="dadaReason" placeholder="请选择取消原因" size="small">
          <el-option
            v-for="item in dadaCancelReasons"
            :key="item.id"
            :label="item.reason"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dadaCancelOrder">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="visibleQrcodeImg"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="管理码"
      width="380px"
    >
      <div style="text-align: center">
        <qrcode :value="qrcodeImg" :options="{ size: 300 }" class="qrcode"></qrcode>
      </div>
    </el-dialog>
    <dialogOrderInfoForWX
      :isShow="isShowWXInfoPopup"
      :WXInfoData="WXInfoData"
      @closeDialog="isShowWXInfoPopup = false"
      @refreshGetData="getPageData"
    >
    </dialogOrderInfoForWX>
    <el-dialog
      title="请扫描核销码"
      :visible.sync="isShowCheck"
      width="496px"
      :before-close="handleClose"
    >
      <div class="check-code">
        <span class="check-code-title">核销码</span>
        <el-input
          ref="checkCodeInput"
          v-model="checkCode"
          placeholder="请输入核销码"
          @keydown.native.tab.prevent
          @blur="focusCheckCodeInput"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getAllOrders,
  getShopTables,
  getOrderNumsByStatus,
  operateOrder,
  handleOrder,
  printOrder,
  createReundOrder,
  getEdcShopGoodsCategorys,
  getEleOrderShipDetail,
  getDeliveryStatusLogMYT,
  createEleOrder,
  manualIssuance,
  querySSDeliverFee,
  queryDDDeliverFee,
  addDDAfterQuery,
  addSSAfterQuery,
  cancelDadaOrder,
  getDadaCancelReasons,
  cancelShansongOrder,
  cancelEleOrder,
  orderCancelMYT,
  getDDOrderInfo,
  getDDlogistics,
  sendOrder,
  exportExcelOrderdetails,
  getOrderInfoFromWX,
  postUpdateOrderStatusByWmOrder,
} from "@/api";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  createBackCategory,
  isSecondaryCategorySwitchOn,
  getSecondaryCategoryList,
} from "@/utils/secondaryCategory";
import takeoutPic from "@/assets/img/order/icon-takeout.png";
import tangPic from "@/assets/img/order/icon-tang.png";
import dyPic from "@/assets/img/order/icon-dy.png";
import md5 from "js-md5";
import { mapState } from "vuex";
import request from "@/utils/request";
import { commonFuc } from "@/mixins/commonFuc";
import { createScannerInput } from "@/utils/scannerInput";
import qrcode from "@xkeshi/vue-qrcode";
import dialogOrderInfoForWX from "@/components/dialogOrderInfoForWX";

let params = null;
let orderList = null;

let cargoWeightInputTimer = null;
export default {
  mixins: [commonFuc],
  data() {
    return {
      visibleQrcodeImg: false,
      qrcodeImg: "",
      takeoutPic: takeoutPic,
      tangPic: tangPic,
      dyPic: dyPic,
      pickupPic: require("@/assets/img/order/icon-pickup.png"),
      orderCondition: "",
      orderConditionPlaceholder: "",
      orderClassifyListBefore: [],
      orderClassifyList: [],
      activeName: "all",
      pageCount: 0,
      tablePositionValue: "all",
      tablePositionList: [
        {
          shoppingTableId: "all",
          tableName: "全部桌位",
        },
      ],
      orderCategory: "",
      orderTime: [],
      startDate: "",
      endDate: "",
      pickerOptions: {
        // 点击时，选择的是开始时间，也就是minDate
        onPick: ({ maxDate, minDate }) => {
          this.selectData = minDate.getTime();
          if (maxDate) {
            // 解除限制
            this.selectData = "";
          }
        },
        disabledDate: (time) => {
          // 是否限制的判断条件
          if (!this.isNull(this.selectData)) {
            var date = new Date(this.selectData);
            // 这里就是限制的关键，大于或者小于本月的日期被禁用
            return (
              date.getMonth() > new Date(time).getMonth() ||
              date.getMonth() < new Date(time).getMonth() ||
              date.getFullYear() > new Date(time).getFullYear() ||
              date.getFullYear() < new Date(time).getFullYear()
            );
          } else {
            return false;
          }
        },
      },
      pageNo: 1,
      pageSize: 5,
      orderList: [],
      isLoad: false,
      orderType: {
        10: {
          title: "待付款",
          class: "black",
        },
        19: {
          title: "待接单",
          class: "red",
          btn: "确认接单",
        },
        20: {
          title: "待发货",
          class: "red",
          btn: "确认发货",
        },
        30: {
          title: "待确认",
          class: "black",
        },
        31: {
          title: "待买单",
          class: "black",
          btn: "确认买单",
        },
        35: {
          title: "待评论",
          class: "black",
          // btn: "原路返回",
        },
        40: {
          title: "已完成",
          class: "black",
          // btn: "原路返回",
        },
        "-10": {
          title: "已关闭",
          class: "red",
        },
        "-20": {
          title: "已取消",
          class: "red",
        },
        "-21": {
          title: "申请退款",
          class: "red",
          btn: "原路返回",
        },
        "-50": {
          title: "退款",
          class: "black",
        },
      },
      isShowDiscountPop: false,
      discount: "",
      tagList: [],
      tagListLv1: [],
      tagChildrenMap: {},
      discountTagListReady: false,
      discountTagListLoading: false,
      tagSecondaryCache: {},
      tagSecondaryPendingMap: {},
      tagSelList: [],
      //是否显示蜂鸟快递信息弹窗
      isShowLogisticsInfo: false,
      logisticsInfoText: {
        1: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        2: {
          title: "骑士正在赶往店内取货",
          desc: "骑士正在赶往店内取货，请提前备好商品",
        },
        3: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        4: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        5: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        7: {
          title: "订单已过期",
          desc: "订单已过期",
        },
        8: {
          title: "指派单",
          desc: "指派单",
        },
        9: {
          title: "配送异常",
          desc: "配送异常，骑手返回途中",
        },
        10: {
          title: "骑士正在店内取货",
          desc: "骑士取货后，订单自动变成已发货状态",
        },
        1000: {
          title: "创建运单失败",
          desc: "创建运单失败",
        },
      },
      eleLogisticsInfoText: {
        1: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        20: {
          title: "骑士正在赶往店内取货",
          desc: "骑士正在赶往店内取货，请提前备好商品",
        },
        2: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        3: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        4: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        7: {
          title: "订单已过期",
          desc: "订单已过期",
        },
        8: {
          title: "指派单",
          desc: "指派单",
        },
        5: {
          title: "配送异常",
          desc: "配送异常，骑手返回途中",
        },
        80: {
          title: "骑士正在店内取货",
          desc: "骑士取货后，订单自动变成已发货状态",
        },
        1000: {
          title: "创建运单失败",
          desc: "创建运单失败",
        },
        0: {
          title: "创建运单",
          desc: "创建运单",
        },
      },
      mtLogisticsInfoText: {
        20: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        30: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        50: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        99: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        0: {
          title: "创建运单",
          desc: "创建运单",
        },
      },
      mytLogisticsInfoText: {
        20: {
          title: "骑士已抢单",
          desc: "骑士已抢单，赶往商家途中",
        },
        40: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        50: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        30: {
          title: "骑士已到店",
          desc: "骑士已到店,等待出餐",
        },
        10: {
          title: "创建订单",
          desc: "已创建订单，等待骑士抢单",
        },
        99: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        0: {
          title: "创建运单",
          desc: "创建运单",
        },
      },
      logisticsInfo: {
        info: {
          // dmName: "毛晓松", //骑手姓名
          // dmMobile: "13587435597", //骑手电话
          // sendType: 2,
          // delivery_party: "", //运力类型(汉字)
          // delivery_longitude: "", //骑手经度
          // delivery_latitude: "", //骑手纬度
        },
        status: [
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 14:15:24",
          //   createTime: "2020-06-05 14:15:24",
          //   isDelete: 0,
          //   orderStatus: 1, ////订单状态(待接单＝1 待取货＝2 配送中＝3 已完成＝4 已取消＝5 已过期＝7 指派单=8 妥投异常之物品返回中=9  已到店=10（蜂鸟需要） 妥投异常之物品返回完成=10 创建达达运单失败=1000
          //   id: 79,
          //   isEnable: 1,
          // },
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 13:21:18",
          //   createTime: "2020-06-05 13:21:18",
          //   isDelete: 0,
          //   orderStatus: 5, //
          //   id: 77,
          //   isEnable: 1,
          // },
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 13:21:18",
          //   createTime: "2020-06-05 13:21:18",
          //   isDelete: 0,
          //   orderStatus: 5, //
          //   id: 77,
          //   isEnable: 1,
          // },
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 13:21:18",
          //   createTime: "2020-06-05 13:21:18",
          //   isDelete: 0,
          //   orderStatus: 5, //
          //   id: 77,
          //   isEnable: 1,
          // },
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 13:21:18",
          //   createTime: "2020-06-05 13:21:18",
          //   isDelete: 0,
          //   orderStatus: 5, //
          //   id: 77,
          //   isEnable: 1,
          // },
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 13:21:18",
          //   createTime: "2020-06-05 13:21:18",
          //   isDelete: 0,
          //   orderStatus: 5, //
          //   id: 77,
          //   isEnable: 1,
          // },
          // {
          //   mallOrderId: 11141,
          //   modifyTime: "2020-06-05 13:21:18",
          //   createTime: "2020-06-05 13:21:18",
          //   isDelete: 0,
          //   orderStatus: 5, //
          //   id: 77,
          //   isEnable: 1,
          // },
        ],
      },
      isShowCargoWeightPop: false,
      cargoWeight: "",
      distributionFee: 0,
      isComputedFee: false,
      dadaCancelReasons: [],
      dadaReason: "",
      isShowDadaCancelReasons: false,
      dadaOrderId: "",
      totalClick: false,
      list: [],
      isShowWXInfoPopup: false,
      WXInfoData: null,

      checkCode: "",
      isShowCheck: false, // 显示核销弹框
    };
  },
  components: {
    qrcode,
    dialogOrderInfoForWX,
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    currentPage() {
      let path = this.$route.path;
      if (path == "/order") {
        this.orderCategory = "";
      } else if (path == "/order/takeout") {
        this.orderCategory = 3;
      } else if (path == "/order/tang") {
        this.orderCategory = 5;
      } else if (path == "/order/dy") {
        this.orderCategory = 24;
      }
      return path;
    },
  },
  watch: {
    activeName(status) {
      this.orderClassifyList.forEach((val) => {
        if (val.orderStatus == status) {
          this.pageCount = val.orderNum;
        }
      });
      this.pageNo = 1;
      this.getPageData();
    },
    currentPage(v) {
      this.activeName = "all";
      this.getPageData();
    },
    orderTime(val) {
      this.startDate = val ? new Date(val[0]).pattern("yyyy-MM-dd") : "";
      this.endDate = val ? new Date(val[1]).pattern("yyyy-MM-dd") : "";
    },
    orderCondition(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    isShowDiscountPop(val) {
      if (!val) {
        this.discount = "";
        orderList = null;
        params = null;
        this.resetDiscountTagView();
      }
    },
  },
  mounted() {
    if (this.isDsType && this.$route.path == "/order") {
      this.$router.push({
        path: "/order/dsOrder",
        params: this.$route.params,
      });
    }
    if (this.$route.params.tradeNo) {
      this.orderTime = [];
      this.orderCondition = this.$route.params.tradeNo;
    }
    if (this.$route.query.shoppingTableId) {
      this.tablePositionValue = Number(this.$route.query.shoppingTableId);
    }
    if (!this.$route.params.tradeNo && !this.$route.query.shoppingTableId) {
      this.getDefaultTime();
    }
    this.getShopTables();
    this.getPageData();
    this.getEdcShopGoodsCategorys();
    this.getDadaCancelReasons();
    this.getOrderNumsByStatus();
    this.checkCodeScanner = createScannerInput({
      getValue: () => this.checkCode,
      setValue: (value) => {
        this.checkCode = value;
      },
      getInput: () => this.getCheckCodeInput(),
      onEnter: async () => {
        const res = await postUpdateOrderStatusByWmOrder({
          verificationCode: this.checkCode,
        });
        if (res.code == 0) {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        } else if (res.code == 1) {
          this.$message({
            type: "success",
            message: "核销成功",
          });
        }
        this.checkCode = "";
      },
      readonlyOnScan: true,
      trapTab: true,
      submitOnEnterAlways: true,
    });
  },
  methods: {
    initTagSecondaryCache(categoryList = []) {
      const cache = Object.assign({}, this.tagSecondaryCache);
      const nextChildrenMap = Object.assign({}, this.tagChildrenMap);
      const nextCache = {};
      (categoryList || []).forEach((item) => {
        if (Number(item.level) !== 2 || !item.parentId) {
          return;
        }
        const parentId = `${item.parentId}`;
        if (!nextCache[parentId]) {
          nextCache[parentId] = [];
        }
        nextCache[parentId].push({
          ...item,
          rawCategoryName: item.rawCategoryName || item.categoryName,
        });
      });
      Object.keys(nextCache).forEach((parentId) => {
        cache[parentId] = nextCache[parentId];
        nextChildrenMap[parentId] = nextCache[parentId];
      });
      this.tagSecondaryCache = cache;
      this.tagChildrenMap = nextChildrenMap;
    },
    buildDiscountTagList(categoryList = []) {
      const nextChildrenMap = {};
      Object.keys(this.tagSecondaryCache).forEach((parentId) => {
        nextChildrenMap[parentId] = (this.tagSecondaryCache[parentId] || []).slice();
      });
      this.tagChildrenMap = nextChildrenMap;
      return (categoryList || [])
        .filter((item) => Number(item.level) !== 2)
        .map((item) => {
          const parentId = `${item.goodsCategoryId}`;
          const parentName = item.rawCategoryName || item.categoryName;
          const children = nextChildrenMap[parentId] || [];
          return {
            ...item,
            displayCategoryName: children.length ? `${parentName}(全部)` : parentName,
            __hasSecondary: children.length > 0,
          };
        });
    },
    rebuildDiscountTagList() {
      this.tagList = this.buildDiscountTagList(this.tagListLv1);
    },
    resetDiscountTagView() {
      this.rebuildDiscountTagList();
    },
    getAllAvailableTagIds() {
      const selectedSet = new Set();
      (this.tagListLv1 || []).forEach((item) => {
        const parentId = `${item.goodsCategoryId}`;
        selectedSet.add(parentId);
        const children = this.tagSecondaryCache[parentId] || [];
        children.forEach((item) => {
          selectedSet.add(`${item.goodsCategoryId}`);
        });
      });
      return Array.from(selectedSet);
    },
    buildSecondaryDiscountTagList(parentItem, secondaryList = []) {
      const parentName = parentItem.rawCategoryName || parentItem.categoryName;
      return [
        createBackCategory(),
        {
          ...parentItem,
          displayCategoryName: `${parentName}(全部)`,
          __isParentAll: true,
          __hasSecondary: true,
        },
        ...secondaryList.map((item) => {
          return {
            ...item,
            __isSecondary: true,
            displayCategoryName: `${parentName}/${
              item.rawCategoryName || item.categoryName
            }`,
          };
        }),
      ];
    },
    async fetchTagSecondaryCategoryList(parentItem) {
      if (!parentItem || !parentItem.goodsCategoryId || !isSecondaryCategorySwitchOn()) {
        return [];
      }
      const parentId = `${parentItem.goodsCategoryId}`;
      if (Object.prototype.hasOwnProperty.call(this.tagSecondaryCache, parentId)) {
        return this.tagSecondaryCache[parentId] || [];
      }
      if (!this.tagSecondaryPendingMap[parentId]) {
        this.tagSecondaryPendingMap[parentId] = getSecondaryCategoryList(
          parentItem.goodsCategoryId,
          9999
        )
          .then((res) => {
            const sourceList =
              res.code == 1 && Array.isArray(res.data)
                ? formatGoodsCategoryListForUI(res.data)
                : [];
            const nextList =
              sourceList.length > 0
                ? sourceList.map((item) => {
                    return {
                      ...item,
                      parentId: item.parentId || parentItem.goodsCategoryId,
                      rawCategoryName: item.rawCategoryName || item.categoryName,
                    };
                  })
                : [];
            this.$set(this.tagSecondaryCache, parentId, nextList);
            this.$set(this.tagChildrenMap, parentId, nextList);
            return nextList;
          })
          .finally(() => {
            delete this.tagSecondaryPendingMap[parentId];
          });
      }
      return this.tagSecondaryPendingMap[parentId];
    },
    async ensureDiscountTagListReady() {
      if (!isSecondaryCategorySwitchOn() || this.discountTagListReady) {
        return;
      }
      if (this.discountTagListLoading) {
        return;
      }
      const hadAllSelected =
        this.tagList.length > 0 &&
        this.tagList.every((item) => {
          return this.tagSelList.indexOf(`${item.goodsCategoryId}`) > -1;
        });
      const pendingParents = (this.tagListLv1 || []).filter((item) => {
        return !Object.prototype.hasOwnProperty.call(
          this.tagSecondaryCache,
          `${item.goodsCategoryId}`
        );
      });
      if (!pendingParents.length) {
        this.discountTagListReady = true;
        this.rebuildDiscountTagList();
        if (hadAllSelected) {
          this.tagSelList = this.getAllAvailableTagIds();
        }
        return;
      }
      this.discountTagListLoading = true;
      try {
        await Promise.all(
          pendingParents.map((item) => {
            return this.fetchTagSecondaryCategoryList(item);
          })
        );
        this.rebuildDiscountTagList();
        if (hadAllSelected) {
          this.tagSelList = this.getAllAvailableTagIds();
        }
        this.discountTagListReady = true;
      } finally {
        this.discountTagListLoading = false;
      }
    },
    async openTagSecondaryCategoryList(parentItem) {
      const children = await this.fetchTagSecondaryCategoryList(parentItem);
      if (!children.length) {
        this.applyTagToggleSelection(parentItem);
        return;
      }
      const parentId = `${parentItem.goodsCategoryId}`;
      if (this.tagSelList.indexOf(parentId) > -1) {
        const selectedSet = new Set(this.tagSelList.map((val) => `${val}`));
        children.forEach((item) => {
          selectedSet.add(`${item.goodsCategoryId}`);
        });
        this.tagSelList = Array.from(selectedSet);
      }
      this.tagList = this.buildSecondaryDiscountTagList(parentItem, children);
    },
    applyTagToggleSelection(item) {
      if (!item || !item.goodsCategoryId) {
        return;
      }
      const id = `${item.goodsCategoryId}`;
      const children = this.tagChildrenMap[id] || [];
      if (item.__isParentAll || children.length) {
        const linkedIds = [id, ...children.map((val) => `${val.goodsCategoryId}`)];
        const isAllSelected = linkedIds.every((categoryId) => {
          return this.tagSelList.indexOf(categoryId) > -1;
        });
        if (isAllSelected) {
          this.tagSelList = this.tagSelList.filter((categoryId) => {
            return linkedIds.indexOf(`${categoryId}`) === -1;
          });
        } else {
          const selectedSet = new Set(this.tagSelList.map((val) => `${val}`));
          linkedIds.forEach((categoryId) => {
            selectedSet.add(categoryId);
          });
          this.tagSelList = Array.from(selectedSet);
        }
        return;
      }
      const currentIndex = this.tagSelList.indexOf(id);
      if (currentIndex > -1) {
        this.tagSelList.splice(currentIndex, 1);
      } else {
        this.tagSelList.push(id);
      }
      if (!item.parentId) {
        return;
      }
      const parentId = `${item.parentId}`;
      const siblingList = this.tagChildrenMap[parentId] || [];
      if (!siblingList.length) {
        return;
      }
      const isAllChildrenSelected = siblingList.every((val) => {
        return this.tagSelList.indexOf(`${val.goodsCategoryId}`) > -1;
      });
      const parentIndex = this.tagSelList.indexOf(parentId);
      if (isAllChildrenSelected) {
        if (parentIndex === -1) {
          this.tagSelList.push(parentId);
        }
      } else if (parentIndex > -1) {
        this.tagSelList.splice(parentIndex, 1);
      }
    },
    getExpandedTagSelList() {
      const selectedSet = new Set();
      this.tagSelList.forEach((id) => {
        const nextId = `${id}`;
        selectedSet.add(nextId);
        const children =
          this.tagChildrenMap[nextId] || this.tagSecondaryCache[nextId] || [];
        children.forEach((item) => {
          selectedSet.add(`${item.goodsCategoryId}`);
        });
      });
      return Array.from(selectedSet);
    },
    getCheckCodeInput() {
      if (
        this.$refs.checkCodeInput &&
        this.$refs.checkCodeInput.$refs &&
        this.$refs.checkCodeInput.$refs.input
      ) {
        return this.$refs.checkCodeInput.$refs.input;
      }
      return null;
    },
    focusCheckCodeInput() {
      if (!this.isShowCheck) {
        return;
      }
      this.$nextTick(() => {
        this.checkCodeScanner.focus();
      });
    },
    handleClose() {
      this.isShowCheck = false;
      this.checkCode = "";
      document.onkeydown = null;
      this.checkCodeScanner.reset();
    },
    // 打开核销弹框
    openCheckCode() {
      this.isShowCheck = true;
      this.checkCodeScanner.reset();
      this.focusCheckCodeInput();
      document.onkeydown = this.checkCodeScanner.handleKeydown;
    },
    createWXInfo(item) {
      this.isShowWXInfoPopup = true;
      this.WXInfoData = item;
    },
    showAuthQrcode(url) {
      this.visibleQrcodeImg = true;
      this.qrcodeImg = url;
    },
    getDefaultTime() {
      const end = new Date(this.$route.query.createTime || new Date());
      const start = new Date(this.$route.query.createTime || new Date());
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      this.startDate = start ? new Date(start).pattern("yyyy-MM-dd") : "";
      this.endDate = end ? new Date(end).pattern("yyyy-MM-dd") : "";
      this.orderTime = [this.startDate, this.endDate];
    },
    // 检查是否为空
    isNull(value) {
      if (value) {
        return false;
      }
      return true;
    },
    getPageData() {
      this.getAllOrders();
    },
    getDadaCancelReasons() {
      getDadaCancelReasons().then((res) => {
        if (res.code == 1) {
          console.log(res);
          this.dadaCancelReasons = res.data;
        }
      });
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: this.pageNo,
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.initTagSecondaryCache(res.data);
          this.tagListLv1 = res.data.filter((item) => Number(item.level) !== 2);
          this.rebuildDiscountTagList();
          this.discountTagListReady =
            !isSecondaryCategorySwitchOn() ||
            this.tagListLv1.every((item) => {
              return Object.prototype.hasOwnProperty.call(
                this.tagSecondaryCache,
                `${item.goodsCategoryId}`
              );
            });
          this.tagSelList = this.discountTagListReady
            ? this.getAllAvailableTagIds()
            : this.tagList.map((val) => `${val.goodsCategoryId}`);
        } else {
          this.tagList = [];
          this.tagChildrenMap = {};
          this.tagSecondaryCache = {};
          this.tagSecondaryPendingMap = {};
          this.discountTagListReady = false;
          this.tagSelList = [];
        }
      });
    },
    getOrderNumsByStatus(cb) {
      getOrderNumsByStatus({
        orderCategorys: this.orderCategory ? this.orderCategory : "3,5",
        // orderCategory: this.orderCategory,
        startDate: this.startDate,
        endDate: this.endDate,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          this.orderClassifyListBefore = res.data;
          let path = this.$route.path;
          let list = [];
          let orderClassifyList = [];
          if (path == "/order") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "未付款",
                orderNum: 0,
                orderStatus: 10,
              },
              {
                orderStatusName: "待接单",
                orderNum: 0,
                orderStatus: 19,
              },
              {
                orderStatusName: "待发货",
                orderNum: 0,
                orderStatus: 20,
              },
              {
                orderStatusName: "待确认",
                orderNum: 0,
                orderStatus: 30,
              },
              {
                orderStatusName: "待买单",
                orderNum: 0,
                orderStatus: 31,
              },
              {
                orderStatusName: "待评论",
                orderNum: 0,
                orderStatus: 35,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
              {
                orderStatusName: "完成退款",
                orderNum: 0,
                orderStatus: -50,
              },
            ];
          } else if (path == "/order/takeout") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "未付款",
                orderNum: 0,
                orderStatus: 10,
              },
              {
                orderStatusName: "待接单",
                orderNum: 0,
                orderStatus: 19,
              },
              {
                orderStatusName: "待发货",
                orderNum: 0,
                orderStatus: 20,
              },
              {
                orderStatusName: "待确认",
                orderNum: 0,
                orderStatus: 30,
              },
              {
                orderStatusName: "待评论",
                orderNum: 0,
                orderStatus: 35,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
              {
                orderStatusName: "完成退款",
                orderNum: 0,
                orderStatus: -50,
              },
            ];
          } else if (path == "/order/tang") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "待接单",
                orderNum: 0,
                orderStatus: 19,
              },
              {
                orderStatusName: "待买单",
                orderNum: 0,
                orderStatus: 31,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
              {
                orderStatusName: "完成退款",
                orderNum: 0,
                orderStatus: -50,
              },
            ];
          } else if (path === "/order/dy") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "未付款",
                orderNum: 0,
                orderStatus: 10,
              },
              {
                orderStatusName: "待接单",
                orderNum: 0,
                orderStatus: 19,
              },
              {
                orderStatusName: "待发货",
                orderNum: 0,
                orderStatus: 20,
              },
              {
                orderStatusName: "待确认",
                orderNum: 0,
                orderStatus: 30,
              },
              {
                orderStatusName: "待买单",
                orderNum: 0,
                orderStatus: 31,
              },
              {
                orderStatusName: "待评论",
                orderNum: 0,
                orderStatus: 35,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
              {
                orderStatusName: "完成退款",
                orderNum: 0,
                orderStatus: -50,
              },
            ];
          }
          orderClassifyList.forEach((val) => {
            this.orderClassifyListBefore.forEach((subval) => {
              if (
                val.orderStatus == subval.orderStatus ||
                (subval.orderStatus == 0 && val.orderStatus == "all")
              ) {
                val.orderNum = subval.orderNum;
              }
            });
            list.push(val);
          });
          list.forEach((val) => {
            if (val.orderStatus == this.activeName) {
              this.pageCount = val.orderNum;
            }
          });
          this.orderClassifyList = list;
        }
      });
    },
    getAllOrders() {
      // console.log(this.activeName, "this.activeName")
      this.isLoad = true;
      this.orderList = [];
      getAllOrders({
        pageNo: this.pageNo,
        row: this.pageSize,
        orderStatus: this.activeName == "all" ? "" : this.activeName,
        orderCategorys: this.orderCategory ? this.orderCategory : "3,5",
        // orderCategory: this.orderCategory,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        startDate: this.startDate,
        endDate: this.endDate,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val, index) => {
            val.productsOem = [];
            val.isShowWXBtn = false;
            val.products.forEach((proVal, proIndex) => {
              if (val.productsOem[proVal.groupId] == undefined) {
                val.productsOem[proVal.groupId] = [];
                val.productsOem[proVal.groupId].push(proVal);
              } else {
                val.productsOem[proVal.groupId].push(proVal);
              }
              if (proIndex == val.products.length - 1) {
                var r = val.productsOem.filter(function (s) {
                  return s;
                });
                val.productsOem = r;
                val.productsOem.reverse();
              }
            });
            if (
              (val.orderStatus == 30 || val.orderStatus == 35 || val.orderStatus == 40) &&
              val.payInterfacePartyType == 3 &&
              (this.shopInfo.edcShopType == 4 || this.shopInfo.edcShopType == 1)
            ) {
              getOrderInfoFromWX({
                mallOrderId: val.mallOrderId,
              }).then((resp) => {
                if (resp.code == 1) {
                  if (resp.data.order_state == 1) {
                    val.isShowWXBtn = true;
                    Object.assign(val, resp.data);
                  }
                }
              });
            }
          });
          this.orderList = res.data;
          console.log(this.orderList);
          if (this.$route.params.tradeNo && this.orderCondition) {
            this.pageCount = res.data.length;
          }
        }
        if (res.code == -1) {
          this.orderList = [];
        }
        this.isLoad = false;
      });
    },
    getShopTables() {
      getShopTables({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.tablePositionList.push(...res.data);
        }
      });
    },
    resetScreenData() {
      this.pageNo = 1;
      this.tablePositionValue = "all";
      this.orderTime = [];
      this.startDate = "";
      this.endDate = "";
      this.orderCondition = "";
      this.getDefaultTime();
      this.getPageData();
    },
    // 全选
    totalChecked() {
      console.log(this.orderList, "this.orderList");
      if (this.orderList.length == 0) {
        this.totalClick = false;
        return;
      }
      this.orderList.forEach((element) => {
        element.click = this.totalClick;
      });
      if (this.totalClick) {
        this.orderList.forEach((element) => {
          this.list.push(element);
          console.log(this.list, "全选");
        });
      } else {
        this.list = [];
        console.log(this.list, "全选");
      }
    },
    commidityClick(item, index) {
      console.log(item, index);
      var arr = this.orderList;
      console.log(item.click, "商品是否选中状态");
      if (item.click == false) {
        this.totalClick = false;
        for (let i in this.list) {
          if (this.list[i].mallOrderId == item.mallOrderId) {
            this.list.splice(i, 1);
          }
        }
        console.log(this.list, "false");
      } else {
        this.totalClick = arr.every((item1) => {
          return item1.click;
        });
        this.list.push(item);
        console.log(this.list, "true");
      }
      this.orderList = "";
      this.orderList = arr;
    },
    // 导出订单
    exportOrders() {
      let activeName = this.activeName == "all" ? "" : this.activeName;
      location.href = `${request.baseUrl}/edcmanageapi/Order_exportOrder?userId=${localStorage.userId}&sessionId=${localStorage.sessionId}&orderStatus=${activeName}&orderCategorys=3,5&startDate=${this.startDate}&endDate=${this.endDate}`;
    },
    // 导出发货单
    exportOrder() {
      console.log(this.startDate, this.endDate, this.orderCondition, "exportOrder");
      location.href = `${request.baseUrl}/edcmanageapi/Order_exportExcelOrderdetails?userId=${localStorage.userId}&sessionId=${localStorage.sessionId}&orderStatus=20&orderCategory=3&startDate=${this.startDate}&endDate=${this.endDate}&keyWord=${this.orderCondition}`;
    },
    // 批量发货
    batchDelivery() {
      console.log(this.list, "批量发货");
      if (this.list.length <= 0) {
        return;
      }
      var ids = "";
      this.list.forEach((ele) => {
        ids += ele.mallOrderId + ",";
      });
      if (ids.length > 0) {
        ids = ids.substr(0, ids.length - 1);
      }
      console.log(ids, "ids");
      // return
      sendOrder({
        mallOrderIds: ids,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.list = [];
          this.getPageData();
          this.getOrderNumsByStatus();
        }
      });
    },
    screenOrder() {
      this.pageNo = 1;
      this.getPageData();
      this.getOrderNumsByStatus();
    },
    tabsChange(val) {},
    searchTable() {},
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    handleEdit(e, index, productIndex, itemIndex) {
      //单个菜品的操作
      let params = {
        mallOrderId: this.orderList[index].mallOrderId,
      };
      params.products = JSON.parse(
        JSON.stringify(this.orderList[index].productsOem[productIndex][itemIndex])
      );
      if (params.products.unitType == 2) {
        this.$confirm(`请确认是否${e == "retreat" ? "退菜" : "赠菜"}`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            params.products.buyCount = 1;
            params.products.productSaleStatus = e == "retreat" ? 1 : 4;
            params.products = JSON.stringify([params.products]);
            this.operateOrder(params);
          })
          .catch(() => {});
      } else {
        this.$prompt(`请输入${e == "retreat" ? "退菜" : "赠菜"}数量`, "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\d+/,
          inputErrorMessage: "必须输入数字",
          inputPlaceholder: "请输入操作数量",
          beforeClose: (action, instance, done) => {
            if (action === "confirm") {
              if (instance.inputValue > 0) {
                done();
              } else {
                this.$notify({
                  title: "提示",
                  message: "数量必须大于0",
                  type: "error",
                  duration: 2000,
                });
              }
            } else {
              done();
            }
          },
        })
          .then(({ value }) => {
            params.products.buyCount = value;
            params.products.productSaleStatus = e == "retreat" ? 1 : 4;
            params.products = JSON.stringify([params.products]);
            this.operateOrder(params);
          })
          .catch(() => {});
      }
    },
    fullHandleEdit(e, index) {
      //整单操作
      params = {
        mallOrderId: this.orderList[index].mallOrderId,
      };
      if (e == "refund") {
        this.$confirm("确认整单退款吗？", "整单退款", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            params.fullOperateType = 1;
            this.operateOrder(params);
          })
          .catch(() => {});
      }
      if (e == "discount") {
        orderList = this.orderList[index];
        this.ensureDiscountTagListReady().finally(() => {
          this.resetDiscountTagView();
          this.isShowDiscountPop = true;
        });
      }
      if (e == "priceRevision") {
        this.$prompt("", "整单改价", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\d+/,
          inputErrorMessage: "必须输入数字",
          inputPlaceholder: "请输入修改后的价格",
        })
          .then(({ value }) => {
            params.fullOperateType = 3;
            params.customPrice = value;
            this.operateOrder(params);
          })
          .catch(() => {});
      }
    },
    toggleSelType(item) {
      if (!item || !item.goodsCategoryId) {
        return;
      }
      if (item.goodsCategoryId == "__back__") {
        this.resetDiscountTagView();
        return;
      }
      if (
        isSecondaryCategorySwitchOn() &&
        item.goodsCategoryId &&
        Number(item.level) !== 2 &&
        !item.__isParentAll
      ) {
        return this.openTagSecondaryCategoryList(item);
      }
      this.applyTagToggleSelection(item);
    },
    discountConfirm() {
      if (!this.discount) {
        return this.$notify({
          title: "提示",
          message: "请填写折扣",
          type: "error",
          duration: 1000,
        });
      }
      if (!this.tagSelList.length) {
        return this.$notify({
          title: "提示",
          message: "请至少选择一个分类",
          type: "error",
          duration: 1000,
        });
      }
      const effectiveTagSelList = this.getExpandedTagSelList();
      let customPrice = 0;
      orderList.products.forEach((val) => {
        if (
          !!~effectiveTagSelList.indexOf(`${val.goodsCategoryId}`) &&
          val.productSaleStatus != 1 &&
          val.productSaleStatus != 4
        ) {
          customPrice += val.retailPrice * val.buyCount * this.discount;
        } else {
          if (val.productSaleStatus != 1 && val.productSaleStatus != 4) {
            customPrice += val.retailPrice * val.buyCount;
          }
        }
      });
      params.fullOperateType = 3;
      params.customPrice = customPrice.toFixed(2);
      this.isShowDiscountPop = false;
      this.operateOrder(params);
    },
    inputChangeLimitNum() {
      this.discount = this.discount.replace(/[^\d.]/g, "");
      this.discount = this.discount.replace(/\.{2,}/g, ".");
      this.discount = this.discount.replace(/^\./g, "0.");
      this.discount = this.discount.replace(
        /^\d*\.\d*\./g,
        this.discount.substring(0, this.discount.length - 1)
      );
      this.discount = this.discount.replace(/^0[^\.]+/g, "0");
      this.discount = this.discount.replace(/^[2-9]/g, "");
      this.discount = this.discount.replace(/^1[.*]/g, "1");
      this.discount = this.discount.replace(/^1[0-9]/g, "1");
      this.discount = this.discount.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
    },
    handleOrder(mallOrderId, orderStatus, payMoney, entryType) {
      let nextOrderStatus = 0;
      if (orderStatus == 19) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 20) {
        nextOrderStatus = 30;
      }
      if (orderStatus == 31) {
        nextOrderStatus = 40;
      }
      if (orderStatus == -22) {
        nextOrderStatus = -22;
      }
      if (orderStatus == -21 || orderStatus == 40) {
        nextOrderStatus = -50;
        // if (entryType != 3 && entryType != 4) {
        this.$prompt("请输入密码", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "password",
        }).then(({ value }) => {
          createReundOrder({
            managerPassWord: String(md5(value)).toUpperCase(),
            mallOrderId: mallOrderId,
          }).then((res) => {
            if (res.code == 1) {
              this.$notify({
                title: "提示",
                message: "退款成功",
                type: "success",
                duration: 1000,
              });
              this.getPageData();
              this.getOrderNumsByStatus();
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 2000,
              });
            }
          });
        });
        return;
        // }
      }
      this.handleOrderFuc(mallOrderId, nextOrderStatus);
    },
    handleOrderFuc(mallOrderId, nextOrderStatus) {
      handleOrder({
        mallOrderId: mallOrderId,
        orderStatus: nextOrderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
          this.getOrderNumsByStatus();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    operateOrder(params) {
      operateOrder(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    copyOrderNo(index) {
      var copyText = document.querySelector(`.order-no${index}`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    printOrder(index) {
      let order = this.orderList[index];
      console.log(order);
      printOrder({
        mallOrderId: order.mallOrderId,
        printStage: order.printStage,
      });
    },
    getLogisticsInfo(sendType, mallOrderId) {
      if (sendType == 5) {
        getEleOrderShipDetail({
          mallOrderId,
        }).then((res) => {
          if (res.code == 1) {
            //   this.logisticsInfo = {
            //     info: {
            //       dmName: res.data.carrierInfo.carrier_driver_name,
            //       sendType: 3,
            //       dmMobile: res.data.carrierInfo.carrier_driver_phone,
            //     },
            //     status: [],
            //   };
            //   res.data.event_log_details.forEach((val) => {
            //     this.logisticsInfo.status.push({
            //       orderStatus: val.order_status,
            //       modifyTime: new Date(val.occur_time).pattern("HH:mm:ss"),
            //     });
            //   });
            this.logisticsInfo = {
              info: {
                dmName: res.data.eleInfo.courier_name,
                sendType: 5,
                dmMobile: res.data.eleInfo.courier_phone,
              },
              status: [],
            };
            res.data.status.forEach((val) => {
              this.logisticsInfo.status.push({
                orderStatus: val.orderStatus,
                modifyTime: new Date(val.modifyTime).pattern("HH:mm:ss"),
              });
            });
            this.isShowLogisticsInfo = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else if (sendType == 6) {
        getDeliveryStatusLogMYT({
          originId: mallOrderId,
        }).then((res) => {
          if (res.code == 1) {
            //   this.logisticsInfo = {
            //     info: {
            //       dmName: res.data.carrierInfo.carrier_driver_name,
            //       sendType: 3,
            //       dmMobile: res.data.carrierInfo.carrier_driver_phone,
            //     },
            //     status: [],
            //   };
            //   res.data.event_log_details.forEach((val) => {
            //     this.logisticsInfo.status.push({
            //       orderStatus: val.order_status,
            //       modifyTime: new Date(val.occur_time).pattern("HH:mm:ss"),
            //     });
            //   });
            this.logisticsInfo = {
              info: {
                dmName: res.data.deliverys[0].rider_name,
                sendType: 6,
                dmMobile: res.data.deliverys[0].rider_phone,
              },
              status: [],
            };
            res.data.deliverys[0].logs.forEach((val) => {
              this.logisticsInfo.status.push({
                orderStatus: val.status,
                modifyTime: val.ctime_format,
              });
            });
            this.isShowLogisticsInfo = true;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        Promise.all([
          getDDOrderInfo({
            mallOrderId: mallOrderId,
          }),
          getDDlogistics({
            mallOrderId: mallOrderId,
          }),
        ]).then((res) => {
          console.log(res);
          if (res[0].code == 1) {
            res[0].data.sendType = sendType;
            this.logisticsInfo.info = res[0].data;
          } else {
            this.$notify({
              title: "警告",
              message: res[0].msg,
              type: "warning",
              duration: 2000,
            });
          }
          if (res[1].code == 1) {
            this.logisticsInfo.status = res[1].data;
          } else {
            this.$notify({
              title: "警告",
              message: res[1].msg,
              type: "warning",
              duration: 2000,
            });
          }
          this.isShowLogisticsInfo = true;
        });
      }
    },
    dadaCancelOrder() {
      cancelDadaOrder({
        mallOrderId: this.dadaOrderId,
        cancelReasonId: this.dadaReason,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "取消配送成功",
            type: "success",
            duration: 2000,
          });
          this.getPageData();
          this.isShowDadaCancelReasons = false;
        } else {
          this.$notify({
            title: "警告",
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
        }
      });
    },
    cancelOrder(sendType, orderId) {
      if (sendType == 2) {
        this.dadaOrderId = orderId;
        this.isShowDadaCancelReasons = true;
      }
      if (sendType == 4) {
        cancelShansongOrder({
          mallOrderId: orderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消配送成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
      if (sendType == 5) {
        cancelEleOrder({
          mallOrderId: orderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消配送成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
      if (sendType == 6) {
        orderCancelMYT({
          originId: orderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "取消配送成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
    },
    showCargoWeightPop(itemInfo) {
      if (this.shopInfo.sendType == 5) {
        this.createEleOrder(itemInfo.mallOrderId);
      } else if (this.shopInfo.sendType == 6) {
        manualIssuance({
          originId: itemInfo.mallOrderId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发货成功",
              type: "success",
              duration: 1000,
            });
            this.getPageData();
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 1000,
            });
          }
        });
      } else {
        this.isShowCargoWeightPop = true;
        this.distributionFee = 0;
        this.originId = itemInfo.mallOrderId;
        this.cargoWeight = "";
      }
    },
    cargoWeightInput() {
      this.cargoWeight = this.cargoWeight.replace(/[^\d.]/g, "");
      this.cargoWeight = this.cargoWeight.replace(/\.{2,}/g, ".");
      this.cargoWeight = this.cargoWeight.replace(/^\./g, "0.");
      this.cargoWeight = this.cargoWeight.replace(
        /^\d*\.\d*\./g,
        this.cargoWeight.substring(0, this.cargoWeight.length - 1)
      );
      this.cargoWeight = this.cargoWeight.replace(/^0[^\.]+/g, "0");
      clearTimeout(cargoWeightInputTimer);
      cargoWeightInputTimer = setTimeout(() => {
        this.isComputedFee = true;
        if (this.shopInfo.sendType == 2) {
          queryDDDeliverFee({
            originId: this.originId,
            cargoWeight: this.cargoWeight,
          }).then((res) => {
            if (res.code == 1) {
              this.distributionFee = res.data.fee;
            } else {
              this.$notify({
                title: "警告",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
            this.isComputedFee = false;
          });
        }
        if (this.shopInfo.sendType == 4) {
          querySSDeliverFee({
            originId: this.originId,
            cargoWeight: this.cargoWeight,
          }).then((res) => {
            if (res.code == 1) {
              this.distributionFee = res.data.fee;
            } else {
              this.$notify({
                title: "警告",
                message: res.msg,
                type: "warning",
                duration: 2000,
              });
            }
            this.isComputedFee = false;
          });
        }
      }, 1000);
    },
    deliveryOrder() {
      if (!this.cargoWeight) {
        return this.$notify({
          title: "警告",
          message: "请输入斤两",
          type: "warning",
          duration: 2000,
        });
      }
      if (!this.distributionFee) {
        return this.$notify({
          title: "警告",
          message: "运费计算中，请稍等",
          type: "warning",
          duration: 2000,
        });
      }
      if (this.shopInfo.sendType == 2) {
        addDDAfterQuery({
          originId: this.originId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发单成功",
              type: "success",
              duration: 2000,
            });
            this.isShowCargoWeightPop = false;
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
      if (this.shopInfo.sendType == 4) {
        addSSAfterQuery({
          originId: this.originId,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "发单成功",
              type: "success",
              duration: 2000,
            });
            this.isShowCargoWeightPop = false;
            this.getPageData();
          } else {
            this.$notify({
              title: "警告",
              message: res.msg,
              type: "warning",
              duration: 2000,
            });
          }
        });
      }
    },
    createEleOrder(mallOrderId) {
      createEleOrder({
        mallOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "发货成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
  }

  .tab-header {
    .top {
      display: flex;

      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;

        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }

        .el-select {
          width: 100%;
        }
      }
    }
  }

  .tab-content {
    display: block;
    padding: 20px;

    .order-list {
      .item {
        border: 1px solid #eeeeee;
        margin-bottom: 20px;

        .list-header {
          background: #f8f8f8;
          height: 48px;
          line-height: 48px;
          padding-left: 18px;

          .order-num {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 10px;
          }

          .delivery-time {
            font-size: 12px;
            color: #f57878;
            margin-right: 10px;
          }

          .suggest,
          .order-no {
            font-size: 12px;
            color: #666666;
          }

          .suggest {
            margin-right: 28px;
          }

          .order-no {
            margin-right: 10px;
          }
        }

        .list-container {
          display: flex;

          & > div {
            border-right: 1px solid #eee;

            &:last-child {
              border-right: 0;
            }
          }

          .products {
            flex: 3.63;

            & > div:last-of-type {
              & > .products-item:last-of-type {
                border-bottom: 0;
              }
            }

            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;

            & > div {
              width: 100%;
            }

            .products-item {
              display: flex;
              height: 70px;
              box-sizing: border-box;
              align-items: center;
              border-bottom: 1px solid #eee;

              .info {
                flex: 5.3;
                display: flex;
                align-items: center;

                .no-img {
                  margin: 0 auto;
                }

                img {
                  width: 50px;
                  height: 50px;
                  margin: 0 10px 0 18px;
                }

                .price {
                  font-size: 12px;
                  line-height: 18px;
                  color: #666666;
                }

                .name {
                  font-size: 12px;
                  line-height: 20px;
                  color: #333333;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }

                .desc {
                  font-size: 12px;
                  line-height: 16px;
                  color: #666;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }

              .num {
                flex: 1.46;
                font-size: 12px;
                color: #333333;
                font-weight: bold;

                .num-type {
                  display: inline-block;
                  border: 1px solid;
                  border-radius: 4px;
                  text-align: center;
                  font-size: 12px;
                  line-height: 22px;
                  box-sizing: border-box;
                  width: 36px;
                  height: 24px;

                  &.retreat {
                    border-color: #fde2e2;
                    background-color: #fef0f0;
                    color: #f57878;
                  }

                  &.give {
                    border-color: #faecd8;
                    background-color: #fdf6ec;
                    color: #e6a45d;
                  }
                }
              }

              .price {
                flex: 2.11;
                width: 130px;
                font-size: 12px;
                color: #666666;
              }

              .action {
                flex: 1.11;
              }
            }
          }

          .time {
            flex: 0.87;
            display: flex;
            flex-direction: column;
            align-items: center;

            & > div {
              display: flex;
              align-items: center;
              flex: 1;
              border-bottom: 1px solid #eeeeee;
              width: 100%;
              justify-content: center;

              &:last-child {
                border-bottom: 0;
              }

              .time-item {
                font-size: 12px;
                color: #999999;
                line-height: 22px;
              }
            }
          }

          & > .info {
            position: relative;
            flex: 1.95;
            padding: 32px 10px 0 15px;
            font-size: 14px;
            line-height: 1;

            .takeoutinfo {
              margin-bottom: 14px;
            }

            .address {
              margin-bottom: 10px;
            }

            .tanginfo {
              color: #333333;

              .position {
                font-weight: bold;
              }

              margin-bottom: 20px;
            }

            .mark {
              color: #ee3030;
            }

            .icon-img {
              position: absolute;
              right: 10px;
              top: 10px;
            }
          }

          & > .price {
            flex: 1.58;
            text-align: center;
            padding-top: 31px;
            padding-bottom: 20px;
            line-height: 1;
            font-size: 14px;

            & > p.total-price,
            .price-msg {
              color: #333333;
              font-weight: bold;
              margin-bottom: 15px;
            }

            & > p.food-box-price {
              font-size: 12px;
              color: #999999;
              margin-bottom: 12px;
            }

            & > p.gain-money {
              color: #ee3030;
              margin-bottom: 20px;
            }
          }

          .action {
            text-align: center;
            padding-top: 30px;
            padding-bottom: 20px;
            flex: 1;

            & > p:nth-of-type(1) {
              font-size: 14px;
              font-weight: bold;

              &.red {
                color: #ee3030;
              }

              &.black {
                color: #000;
              }
            }

            .reason {
              color: #e6a23c;
            }

            & > .el-button--primary {
              margin-top: 15px;
            }

            .el-button + .el-button {
              &.create-btn {
                display: block;
                margin-left: 0;
                margin: 10px auto 0;
              }

              margin-left: 2px;
            }

            .status-btn {
              display: block;
              margin-left: 0;
              margin: 10px auto 0;
            }
          }

          .print {
            text-align: center;
            padding-top: 20px;
            flex: 1;

            .check-logistics {
              display: block;
              margin: 10px auto 0;
            }
          }
        }
      }
    }

    .list-none {
      text-align: center;
      font-size: 14px;
      color: #999999;
      padding-top: 20px;
    }
  }

  .el-dialog {
    .el-select {
      width: 100%;
    }
  }

  .tag-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    padding: 20px 0 10px;

    .tag {
      min-width: 90px;
      max-width: 100%;
      height: 30px;
      line-height: 30px;
      text-align: center;
      padding: 0 12px;
      background: url(../assets/img/order/bg-unsel.png) no-repeat top left/ 100% 100%;
      margin: 0 12px 10px 0;
      cursor: pointer;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;

      &.sel {
        background: url(../assets/img/order/bg-sel.png) no-repeat top left/ 100% 100%;
      }

      &.tag-parent {
        font-weight: 600;
      }

      &.tag-child {
        min-width: 120px;
      }
    }
  }

  .logistics-dialog {
    .logistics-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-radius: 6px;
      background: #f6fbff;
      padding: 14px 10px;

      .icon {
        width: 46px;
        height: 46px;
        margin-right: 10px;
      }

      .info {
        font-size: 12px;
        color: #409eff;
        line-height: 1;

        .name {
          margin-bottom: 8px;

          .tag {
            display: inline-block;
            padding: 3px 6px;
            background: #409eff;
            border-radius: 20px;
            border-bottom-left-radius: 0;
            font-size: 12px;
            line-height: 1;
            color: #fff;
            margin-left: 6px;
          }
        }
      }
    }

    .logistics-body {
      min-height: 500px;
      max-height: 500px;
      overflow: auto;
      margin-top: 22px;

      .el-steps-oem {
        padding: 10px;

        .el-step-oem {
          position: relative;
          padding-left: 40px;
          padding-bottom: 34px;

          &.active {
            &:not(:last-child)::before {
              background: #409eff;
            }

            .index {
              border-color: #409eff;
              color: #409eff;
            }
          }

          &:not(:last-child)::before {
            position: absolute;
            content: "";
            top: 0;
            bottom: 0;
            left: 12px;
            width: 2px;
            background: #c0c4cc;
          }

          .index {
            position: absolute;
            border: 2px solid #c0c4cc;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
            font-size: 14px;
            color: #c0c4cc;
            left: 0;
            top: -5px;
            border-radius: 50%;
            background: #fff;
            font-weight: bold;
          }

          .desc,
          .time {
            font-size: 12px;
            color: #666666;
          }

          .title {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            position: relative;
            top: -5px;

            &.active {
              color: #409eff;
            }
          }
        }
      }
    }
  }

  .dialog-row {
    line-height: 50px;
    font-size: 18px;
    padding: 0 10px;
  }

  .check-code {
    display: flex;
    align-items: center;

    &-title {
      width: 50px;
      margin-right: 30px;
    }
  }
}
</style>

<style lang="less">
.el-transfer-panel__item {
  display: block;
}

.el-select-dropdown {
  width: 150px;
}
</style>
